var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("D:/Cloud/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/time-range.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-time-range\">\n    <form target=\"#\" class=\"form-horizontal cm-form\">\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("inputs"))(env, context, frame, runtime, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
output += t_1;
output += "\n        ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("presets"))(env, context, frame, runtime, function(t_4,t_3) {
if(t_4) { cb(t_4); return; }
output += t_3;
output += "\n    </form>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_inputs(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
output += "<div class=\"cm-input\">\n            <label for=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-to-date\">From date:</label>\n            <input type=\"text\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-to-date\" name=\"time-to\" class=\"cm-time-from-input\">\n        </div>\n        <div class=\"cm-input\">\n            <label for=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-from-date\">To date:</label>\n            <input type=\"text\" id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "-from-date\" name=\"time-from\" class=\"cm-time-to-input\" >\n        </div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_presets(env, context, frame, runtime, cb) {
var lineno = 12;
var colno = 11;
var output = "";
try {
var frame = frame.push(true);
output += "<div class=\"cm-radio-group cm-time-range-radio\">\n            <label><input type=\"radio\" value=0 name=\"time-range\" checked> Flexible</label>\n            ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "rangePresets");
if(t_7) {t_7 = runtime.fromIterator(t_7);
var t_5;
if(runtime.isArray(t_7)) {
var t_6 = t_7.length;
for(t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5][0];
frame.set("[object Object]", t_7[t_5][0]);
var t_9 = t_7[t_5][1];
frame.set("[object Object]", t_7[t_5][1]);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n            <label><input type=\"radio\" value=\"";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "\" name=\"time-range\"> ";
output += runtime.suppressValue(t_9, env.opts.autoescape);
output += "</label>\n            ";
;
}
} else {
t_5 = -1;
var t_6 = runtime.keys(t_7).length;
for(var t_10 in t_7) {
t_5++;
var t_11 = t_7[t_10];
frame.set("r", t_10);
frame.set("label", t_11);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n            <label><input type=\"radio\" value=\"";
output += runtime.suppressValue(t_10, env.opts.autoescape);
output += "\" name=\"time-range\"> ";
output += runtime.suppressValue(t_11, env.opts.autoescape);
output += "</label>\n            ";
;
}
}
}
frame = frame.pop();
output += "\n        </div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_inputs: b_inputs,
b_presets: b_presets,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/time-range.html"] , dependencies)